import { SearchInput } from 'components/search/SearchInput';
import { TreeItemGroupLabelText } from 'pages/workbench/side_panel/workbench_tree/styled';
import styled from 'styled-components';

export const TreeItemLabelText = styled(TreeItemGroupLabelText)`
    font-size: 1.4rem;
`;

export const StyledSearchInput = styled(SearchInput)`
    font-size: 1.4rem;
    padding: 1rem;
    align-items: center;
    border-radius: 3px;
    border: 2px solid var(--grey-default);
    background-color: var(--surface-subtle);
`;
